import { BaseRecordSchema, defineValidation } from "../../common/validation.common";

export namespace MarketingSubscriptionValidation {
    export const Record = defineValidation(BaseRecordSchema);
}
